const separateFormats = (time: number) => {
  const length = time && time > 0 ? time : 0
  const _hours = Math.floor(length / 3600) % 24
  const hours = _hours >= 10 ? _hours : `0${_hours}`

  const _minutes = Math.floor(length / 60) % 60
  const minutes = _minutes >= 10 ? _minutes : `0${_minutes}`

  const _seconds = Math.floor(length % 60)
  const seconds = _seconds >= 10 ? _seconds : `0${_seconds}`

  return {
    minutes: String(minutes),
    seconds: String(seconds),
    hours: String(hours)
  }
}

export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60)
  const sec = Math.floor(seconds % 60)
  const milliseconds = Math.floor((seconds - Math.floor(seconds)) * 10)

  return `${String(minutes).padStart(2, '0')}:${String(sec).padStart(2, '0')}:${milliseconds}`
}

export const timeFormatter = (
  duration: number,
  showDecSecond = false
): string => {
  // Here we round duration to one number after dot if needed
  const durationConvertedToString = String(Math.round(duration * 10) / 10)
  const decSecondValue = Number(durationConvertedToString.split('.')[1])
  const decSecond = showDecSecond && decSecondValue ? `.${decSecondValue}` : ''

  const { minutes, seconds, hours } = separateFormats(duration)
  return Number(hours)
    ? `${hours}:${minutes}:${seconds}${decSecond}`
    : `${minutes}:${seconds}${decSecond}`
}
